/** *@name:index *@author:dingyongya *@date:2022/9/21 13:58 *@update:2022/9/21 13:58 */

<template>
  <div class="mg-virtual-table mg-vxe-table" :class="tableLineClass">
    <div class="mg-virtual-table-topbar" v-if="isShowTopBar">
      <div class="topbar-left">
        <strong v-if="showTitle" :style="{ fontSize: $pxToRem(24), fontWeight: 600 }">{{ title }}</strong>
        <slot name="topleft" />
      </div>
      <div class="topbar-right">
        <slot name="topright" />
        <template v-if="searchable">
          <el-button
            v-if="!showSearchBar"
            icon="iconfont mg-icon_sousuo_wubiankuang"
            size="mini"
            :disabled="false"
            @click="handleShowSearch"
            type="icon"
          />
          <el-button
            v-else
            plain
            :disabled="false"
            icon="iconfont mg-icon_sousuo_wubiankuang"
            size="mini"
            @click="handleShowSearch"
            type="icon"
          />
        </template>
        <el-button
          class="mg-setting-icon-btn"
          :disabled="false"
          type="icon"
          @click="visible = true"
          v-if="configurable"
        >
          <span class="mg-setting-icon-img" />
        </el-button>
        <mg-mini-pagination
          v-if="showMiniPagination"
          :page="page"
          :total="total"
          :total-page="totalPage"
          @page-change="handlePageChange"
        />
      </div>
    </div>
    <slot name="middle" />
    <!-- chronological 只对 multiple 有效，是否按照先后触发顺序进行排序 -->
    <div ref="vxeTableWrapperRef" :style="getTableContainerHeight">
      <vxe-table
        :class="['vxe-table-box', readonly ? 'readonly' : '']"
        v-loading="loading"
        :border="resolvedTableBorder"
        show-overflow="ellipsis"
        show-footer-overflow="ellipsis"
        ref="mgTable"
        auto-resize
        height="auto"
        :sync-resize="true"
        show-header-overflow="title"
        :data="initialData || list"
        :scroll-y="{ mode: 'wheel', gt: 100 }"
        :scroll-x="{ gt: scrollXGt, enabled: scrollXEnable }"
        :filter-config="{ showIcon: false }"
        :checkbox-config="{
          highlight: true,
          checkRowKeys: checkRowKeys,
          checkMethod: this.checkMethod,
          ...$attrs['checkbox-config'],
        }"
        :sort-config="{
          iconAsc: 'el-icon-caret-top',
          iconDesc: 'el-icon-caret-bottom',
          remote: sortRemote,
          multiple: multipleSort,
          sortMethod: sortMethod,
          chronological: true,
        }"
        @sort-change="multiSortChange"
        :row-config="{
          keyField: 'id',
          isHover: true,
          isCurrent: isCurrentRow,
          ...$attrs['row-config'],
        }"
        :column-config="{ isCurrent: isCurrentColumn, resizable: true }"
        :seq-config="{ seqMethod: showPagination || showMiniPagination ? this.seqMethod : null }"
        :resizable-config="{ minWidth: 50 }"
        :keyboard-config="{ isEnter: true, isArrow: true, ...$attrs['keyboard-config'] }"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
        :mouse-config="{ selected: cellSelectedStatus }"
        @keydown="handleKeydown"
        @cell-selected="cellSelected"
        :footer-method="$attrs['footer-method'] || footerMethod"
        :row-class-name="handleRowClassName"
        :header-cell-class-name="calcCellName"
        @cell-click="handleCell"
        @checkbox-change="selectChangeEvent"
        @checkbox-all="selectAllEvent"
        @resizable-change="resizableChange"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <slot name="checkbox"></slot>
        <!-- 自定义表格内容 -->
        <!--
				外面再包一层template是因为：
				columns添加可配置后，其依赖接口取值，
				而本地又有一份静态columns，导致缓存列的存在，
				对于下面默认插槽的渲染会走进该模板的渲染，导致dom渲染异常
			-->
        <template v-if="columns.length > 0">
          <template v-for="column in renderVisibleColumns">
            <!-- 表头分组	-->
            <mg-vxe-colgroup
              v-if="column.children && column.children.length > 0"
              :key="column.prop || column.type"
              :column="column"
              :show-search-bar="showSearchBar"
              :header-search="headerSearch"
              :filter-method="filterMethod"
            >
              <template #headerInputCol="{ scoped }">
                <el-input
                  :disabled="false"
                  v-if="headerSearch && scoped.item?.headerSearch"
                  v-model="filterForm[scoped.item.prop]"
                  @keyup.enter.native="handleEnterHeaderSearch"
                />
                <div v-if="scoped.item?.type === 'seq'" class="mg-header-search-reset-wrap">
                  <el-button
                    :disabled="false"
                    type="text"
                    class="mg-header-search-reset-btn"
                    size="mini"
                    @click="clearFilter"
                  >
                    {{ $MGUI.i18n.t('重置') }}
                  </el-button>
                </div>
              </template>
              <template #headerSlotCol="item">
                <slot :name="item.headerSlot" v-bind="item"></slot>
              </template>
              <!-- slot 有值	-->
              <template #default="{ scoped }">
                <slot :name="scoped.item.slot" v-bind="{ ...scoped, index: scoped.rowIndex }" />
              </template>
              <!-- default: true	-->
              <template #bodyContent="scoped">
                <slot :name="scoped.prop" v-bind="scoped"></slot>
              </template>
            </mg-vxe-colgroup>
            <template v-else>
              <mg-vxe-column
                v-if="column.slot && !column.hidden"
                :column="column"
                :key="column.prop"
                :show-search-bar="showSearchBar"
                :header-search="headerSearch"
                :filter-method="filterMethod"
              >
                <template #headerInput>
                  <el-input
                    :disabled="false"
                    v-if="headerSearch && column.headerSearch"
                    v-model="filterForm[column.prop]"
                    @keyup.enter.native="handleEnterHeaderSearch"
                  />
                  <div v-if="column.type === 'seq'" class="mg-header-search-reset-wrap">
                    <el-button
                      :disabled="false"
                      type="text"
                      class="mg-header-search-reset-btn"
                      size="mini"
                      @click="clearFilter"
                    >
                      {{ $MGUI.i18n.t('重置') }}
                    </el-button>
                  </div>
                </template>

                <template #headerSlot>
                  <slot :name="column.headerSlot"></slot>
                </template>
                <template #default="scoped">
                  <slot :name="column.slot" v-bind="{ ...scoped, index: scoped.rowIndex }" />
                </template>
              </mg-vxe-column>
              <!-- 使用默认表格列渲染 -->
              <template v-else-if="column.default && !column.hidden">
                <slot :name="column.prop" v-bind="column" />
              </template>
              <!-- 常规数值显示的表格行 -->
              <mg-vxe-column
                v-else-if="!column.hidden"
                :column="column"
                :key="column.prop"
                :show-search-bar="showSearchBar"
                :header-search="headerSearch"
                :filter-method="filterMethod"
              >
                <template #headerInput>
                  <el-input
                    :disabled="false"
                    v-if="headerSearch && column.headerSearch"
                    v-model="filterForm[column.prop]"
                    @keyup.enter.native="handleEnterHeaderSearch"
                  />
                  <div v-if="column.type === 'seq'" class="mg-header-search-reset-wrap">
                    <el-button
                      :disabled="false"
                      type="text"
                      class="mg-header-search-reset-btn"
                      size="mini"
                      @click="clearFilter"
                    >
                      {{ $MGUI.i18n.t('重置') }}
                    </el-button>
                  </div>
                </template>
                <template #headerSlot>
                  <slot :name="column.headerSlot"></slot>
                </template>
              </mg-vxe-column>
            </template>
          </template>
        </template>
        <div slot="empty" class="empty-placeholder">
          <img src="@/assets/common/empty-icon.png" />
          <div>{{ $MGUI.i18n.t('暂无内容') }}</div>
        </div>
        <slot></slot>
      </vxe-table>
    </div>
    <el-pagination
      class="mg-pagination"
      v-if="showPagination"
      background
      :current-page="page"
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pagination.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <mgColumnConfig
      v-if="visible"
      :visible.sync="visible"
      :columns.sync="renderVisibleColumns"
      @column-change="handleColumnChange"
    />
  </div>
</template>

<script>
  import ConfigColumn from '../../table/mixins/column-config'
  import mgMiniPagination from '../../table/components/mg-mini-pagination'
  import mgColumnConfig from '../../table/components/mg-column-config'
  import mgVxeColumn from './components/mgVxeColumn'
  import mgVxeColgroup from './components/mgVxeColgroup'
  import { cloneDeep } from 'lodash-es'
  export default {
    mixins: [ConfigColumn],
    name: 'mgVxeTable',
    provide() {
      return {
        hiddenHeaderStar: this.hiddenHeaderStar,
      }
    },
    props: {
      // 合计字段名称
      summaryFields: {
        type: String,
        default: '',
      },
      // 是否开启横向虚拟滚动
      scrollXEnable: {
        type: Boolean,
        default: false,
      },
      scrollXGt: {
        type: Number,
        default: 25,
      },
      // 是否可配置
      configurable: {
        type: Boolean,
        default: true,
      },
      hiddenHeaderStar: {
        type: Boolean,
        default: false,
      },
      columns: {
        type: Array,
        default: () => [],
      },
      // 是否启用多字段组合排序
      multipleSort: {
        type: Boolean,
        default: false,
      },
      // 详情页面
      readonly: {
        type: Boolean,
        default: false,
      },
      // 是否启用服务器排序
      sortRemote: {
        type: Boolean,
        default: true,
      },
      sortMethod: Function,
      multiSortChange: {
        type: Function,
        default: () => {},
      },
      // 是否启用搜索
      searchable: {
        type: Boolean,
        default: false,
      },
      // 是否启用合计
      showSummary: {
        type: Boolean,
        default: false,
      },
      // 合计对象
      summaryOption: {
        type: Object,
        default: () => {},
      },
      data: {
        type: Array,
        default: () => [],
      },
      initialData: Array,
      api: Function,
      formatData: Function, // 处理后台数据格式
      apiParams: Object, // 列表查询初始化参数
      autoLoad: Boolean, // 是否自动加载列表数据
      headerSearch: Boolean, // 是否启用表头搜索
      // 需要查询参数对象 headerSearch 为false 时自定义表头搜索
      filtersForm: {
        type: Object,
        default: () => {},
      },
      // 是否开启远程表头搜索，回车触发
      remoteHeaderSearch: Boolean,
      // 是否启用编辑表格回车自动换行获取焦点
      cellSelectedStatus: {
        type: Boolean,
        default: true,
      },
      // 是否需要显示分页
      showPagination: {
        type: Boolean,
        default: false,
      },
      // 点击当前列不选中行
      checkboxColumnOff: {
        type: Array,
        default: () => [],
      },
      // 默认勾选指定行（只会在初始化时被触发一次，需要有 row-id）
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      // 默认指定行不能勾选（只会在初始化时被触发一次，需要有 row-id）
      disabledList: {
        type: Array,
        default: () => [],
      },
      // 合计金额字段
      amountColumns: {
        type: Array,
        default: () => [],
      },
      // 数量金额字段
      quantityColumns: {
        type: Array,
        default: () => [],
      },
      //实际退款金额字段
       infactReturnAmtColumns: {
        type: Array,
        default: () => [],
      },
      // 列表行是否可点
      isRowClick: {
        type: Boolean,
        default: false,
      },
      // 是否显示顶部bar
      isShowTopBar: {
        type: Boolean,
        default: true,
      },
      // 添加行样式
      rowClassValues: {
        type: Object,
        default: null,
      },
      // 添加列样式
      columnClassValues: {
        type: Array,
        default: null,
      },
      // 是否需要mini显示分页
      showMiniPagination: {
        type: Boolean,
        default: true,
      },
      isCurrentRow: {
        type: Boolean,
        default: true,
      },
      isCurrentColumn: {
        type: Boolean,
        default: false,
      },
      title: String,
      // 根据表格外部包裹的div高度计算内部表格的高度
      wrapperHeight: {
        type: String,
        default: '30rem',
      },
      // 表格线条模式：horizontal=仅横线，full=完整边框
      tableLineMode: {
        type: String,
        default: 'horizontal',
        validator(value) {
          return ['horizontal', 'full'].includes(value)
        },
      },
    },
    components: {
      mgMiniPagination,
      mgColumnConfig,
      mgVxeColumn,
      mgVxeColgroup,
    },
    data() {
      return {
        summaryFieldsOptions: {},
        visible: false,
        multiple: false,
        activeColIndex: 0,
        activeRowIndex: 0,
        showSearchBar: false,
        selectList: [],
        pagination: {
          page: this.apiParams?.page || 1,
          size: this.apiParams?.size || 20,
        },
        list: this.$attrs.data,
        loading: false,
        total: 0,
        // 后端全量合计数据放在这个参数中
        summarySums: [],
        keydownCode: '',
        propsList: [],
        currentProp: '',
        filterForm: {},
        vxeTableContainerOffsetTop: 0,
      }
    },
    computed: {
      getTableContainerHeight() {
        return {
          height: `calc(${this.wrapperHeight} - ${this.$pxToRem(this.vxeTableContainerOffsetTop)})`,
        }
      },
      multipleSortBtnStyle() {
        return this.multiple
          ? { color: '#e60012', borderColor: '#f8b3b8', backgroundColor: '#fde6e7' }
          : { color: '#252a3d', borderColor: '#dcdfe6', backgroundColor: '#ffffff' }
      },
      page() {
        return this.pagination.page
      },
      totalPage() {
        return Math.ceil(this.total / this.pagination.size)
      },
      showTitle() {
        return !!this.title
      },
      resolvedTableBorder() {
        if (this.$attrs.border !== undefined) return this.$attrs.border
        // 默认保留 full，避免影响列宽拖拽等交互命中
        return 'full'
      },
      tableLineClass() {
        return this.tableLineMode === 'horizontal' ? 'mg-vxe-table--line-horizontal' : ''
      },
    },
    watch: {
      selectList: function (val) {
        this.$emit('selection-change', val)
      },
      summaryOption: {
        handler() {
          this.$refs.mgTable.updateFooter()
        },
        deep: true,
      },
      filterForm: {
        handler(newVal) {
          if (this.remoteHeaderSearch) return

          if (!newVal) return
          Object.keys(newVal).forEach((key) => {
            if (!this.propsList.includes(key)) return
            const column = this.$refs.mgTable.getColumnByField(key)
            if (!column) return
            this.filterChange(column.property, newVal[key])
          })
        },
        deep: true,
      },
    },
    created() {
      if (this.headerSearch) {
        this.propsList = this.getPropList(this.columns)
      }
    },
    mounted() {
      if (this.autoLoad && this.api) {
        this.loadData()
      }
      if (this.headerSearch) {
        this.filterForm = this.filtersForm
      }
      this.calcVxeTableOffsetTop()
    },
    updated() {
      this.calcVxeTableOffsetTop()
    },
    methods: {
      //2025.9.26添加 start
      //手动加载数据 计划用于api再列表中自行调用
      async manualLoadData(){
         if(this.api){
           this.pagination.page = 1
           await this.loadData()
         }
      },
      //2025.9.26添加 end
      calcVxeTableOffsetTop() {
        const pt = window.getComputedStyle(this.$el).getPropertyValue('padding-top') || 0
        this.vxeTableContainerOffsetTop = this.$refs.vxeTableWrapperRef.offsetTop - parseInt(pt)
      },
      // 递归prop
      getPropList(data) {
        return data.reduce((prev, curr) => {
          if (curr.prop) prev.push(curr.prop)
          if (curr.children) {
            return [...prev, ...this.getPropList(curr.children)]
          }
          return prev
        }, [])
      },
      getPropEditList(data) {
        return data.reduce((prev, curr) => {
          if (curr.edit) prev.push(curr.prop)
          if (curr.children) {
            return [...prev, ...this.getPropEditList(curr.children)]
          }
          return prev
        }, [])
      },
      // cell 选中
      cellSelected({ row, $event }) {
        if (['ArrowRight', 'ArrowLeft'].includes(this.keydownCode)) {
          this.$refs.mgTable.setSelectCell(row, this.currentProp)
        }
        if (
          ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Enter'].includes(this.keydownCode) &&
          this.$refs.mgTable.getSelectedCell().cell?.querySelector('input')
        ) {
          if ($event.type === 'keydown') {
            this.$refs.mgTable.getSelectedCell().cell?.querySelector('.el-input').querySelector('input')?.focus()
          }
        }
      },
      // 回车code 获取
      handleKeydown({ $event }) {
        this.currentProp = this.$refs.mgTable.getSelectedCell()?.column?.property || this.currentProp
        this.keydownCode = $event.code
        let propertyList = this.getPropEditList(this.columns)
        const index = propertyList.findIndex((proerty) => this.currentProp === proerty)
        if (this.keydownCode === 'ArrowRight') {
          this.currentProp = propertyList[index + 1]
          return
        }
        if (this.keydownCode === 'ArrowLeft') {
          this.currentProp = propertyList[index - 1]
          return
        }
      },
      // 分页序号处理
      seqMethod({ rowIndex }) {
        return rowIndex + 1 + (this.page - 1) * this.pagination.size
      },
      // 添加表头class
      calcCellName({ column }) {
        // 使用过滤的排序添加sort_right 表头排序按钮右定位
        const filtersKey = Object.keys(this.filtersForm ?? '')
        const isFilterClass = filtersKey.includes(column.property)

        // 通过 columnClassValues 设置多列高亮
        const isHighlightClass = this.columnClassValues?.includes(column.property)

        return `${isFilterClass ? 'sort_right' : ''} ${isHighlightClass ? 'vxe-column-bg' : ''}`
      },

      // 重置columns
      handleResetColumns(columns) {
        this.handleColumnChange(columns)
      },
      async loadData() {
        this.$emit('loading', true)
        this.loading = true
        return new Promise((resolve, reject) => {
          this.api({
            ...this.apiParams,
            ...this.pagination,
          })
            .then(async (res) => {
              if (typeof this.formatData === 'function') {
                await this.formatData(res.data?.items)
              }
              if (this.summaryFields) {
                this.summaryFieldsOptions = res.data[this.summaryFields]
              }
              this.list = res.data?.items
              this.$emit('update:initialData', [...(this.list || [])])
              this.total = res.data?.total || 0
              if (this.pagination.page > 1 && this.list.length === 0) {
                this.pagination.page = 1
                this.loadData()
              }
              resolve(res)
            })
            .catch((err) => {
              reject(err)
            })
            .finally(() => {
              this.loading = false
              this.$emit('loading', false)
              if (this.$attrs['show-summary']) {
                this.$nextTick(() => {
                  this.$refs.mgTable.updateFooter()
                })
              }
            })
        })
      },
      handleCurrentChange(page) {
        this.pagination.page = page
        this.loadData()
      },
      handleSizeChange(size) {
        this.pagination.page = 1
        this.pagination.size = size
        this.loadData()
      },
      handlePageChange(page) {
        this.handleCurrentChange(page)
      },

      // 合计
      footerMethod({ columns, data }) {
        let summaryFiled = []
        let summaryObj = {}
        if (this.summaryFields) {
          summaryObj = this.summaryFieldsOptions
          summaryFiled = this.summaryFieldsOptions ? Object.keys(this.summaryFieldsOptions) : []
        } else {
          summaryObj = this.summaryOption
          summaryFiled = this.summaryOption ? Object.keys(this.summaryOption) : []
        }
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$MGUI.i18n.t('合计')
            }
            if (summaryFiled.length > 0) {
              if (summaryFiled.includes(column.property)) return this.amount(summaryObj[column.property])
            } else if (this.amountColumns.length > 0 || this.quantityColumns.length > 0 || this.infactReturnAmtColumns.length > 0) {
              // 金额列合计
              if (this.amountColumns.includes(column.property)) {
                const values = data.map((item) => item[column.property] || 0)
                const total = values.reduce((sum, value) => (sum = new this.$MGUI.BN(sum).plus(value).toFixed(2)), 0)
                return this.amount(total)
              }
              // 数量列合计
              if (this.quantityColumns.includes(column.property)) {
                const values = data.map((item) => item[column.property] || 0)
                const total = values.reduce((sum, value) => (sum = new this.$MGUI.BN(sum).plus(value)), 0)
                return this.amount(total)
              }
              //实际退款金额列合集
              if(this.infactReturnAmtColumns.includes(column.property)){
                const values = data.map((item) => item[column.property] || 0)
                const total = values.reduce((sum, value) => (sum = new this.$MGUI.BN(sum).plus(value)), 0)
                return this.amount(total)
              }
            }
            return null
          }),
        ]
      },
      amount: (value) => {
        if (!value) return value
        return value.toString().replace(/\d+/, (n) => {
          return n.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
        })
      },
      // 默认不能选中
      checkMethod({ row }) {
        return !this.disabledList.includes(row[this.$attrs['row-id']])
      },
      // 选中所有
      selectAllEvent({ records }) {
        this.selectList = records
      },
      // 选择当行
      selectChangeEvent({ records }) {
        this.selectList = records
      },
      // 单击行
      handleCell({ row, column }) {
        // 单击高亮行 or 取消高亮
        let highlightRows = this.rowClassValues ? cloneDeep(this.rowClassValues) : {}
        highlightRows.fieldValue = highlightRows?.fieldKey === 'id' ? highlightRows?.fieldValue ?? [] : []
        highlightRows.fieldKey = 'id'
        const index = highlightRows.fieldValue.findIndex((item) => item === row.id)
        index == -1 ? highlightRows.fieldValue.push(row.id) : highlightRows.fieldValue.splice(index, 1)
        this.$emit('update:rowClassValues', highlightRows)

        if (!this.isRowClick) return false
        if (!this.checkboxColumnOff.includes(column.property) && column.type !== 'checkbox' && column.property) {
          this.$refs.mgTable.toggleCheckboxRow(row)
          this.selectList = this.$refs.mgTable.getCheckboxRecords()
        }
      },
      // 删除行
      remove(rows) {
        if (rows) {
          this.$refs.mgTable.remove(rows)
        }
      },
      /**start---- --------------表头过滤开始-----------------------*/
      // 表头搜索按钮点击
      handleShowSearch() {
        this.showSearchBar = !this.showSearchBar
        this.$nextTick(() => {
          this.$refs.mgTable.recalculate(true)
        })
        this.clearFilter({ isFromShowSearch: true })
        this.$emit('searchable-change', this.showSearchBar)
      },
      // 回车表头搜索监听
      handleEnterHeaderSearch() {
        if (this.remoteHeaderSearch) this.$emit('handleEnterHeaderSearch', this.filterForm)
      },
      // 统一过滤方法
      filterMethod(config, column) {
        if (!this.filterForm[column]) return true
        return (
          config.row[column]
            ?.toString()
            .toLocaleLowerCase()
            .indexOf(this.filterForm[column]?.toString().toLocaleLowerCase()) >= 0
        )
      },
      /**
       * 过滤数据
       */
      filterChange(key, values) {
        const column = this.$refs.mgTable.getColumnByField(key)
        const xTable = this.$refs.mgTable
        const columns = xTable.getColumnByField(column.property)
        // 修改第二个选项为勾选状态
        const option = columns.filters[0]
        option.data = values
        option.checked = true
        // 修改条件之后，需要手动调用 updateData 处理表格数据
        xTable.updateData()
        xTable.updateFooter()
      },
      /**
       * 清除过滤条件
       * @param //  isFromShowSearch 是否是点击搜索图标
       */
      // eslint-disable-next-line no-unused-vars
      clearFilter({ isFromShowSearch = false, ...rest }) {
        this.$refs.mgTable.clearFilter()
        Object.keys(this.filterForm).forEach((key) => {
          this.filterForm[key] = ''
        })
        if (this.remoteHeaderSearch && !isFromShowSearch) this.$emit('handleEnterHeaderSearch', this.filterForm)
      },
      /**end---- --------------表头过滤结束-----------------------*/

      /**
       * fieldKey String 例如：'skuCode'
       * fieldValues Array 例如：['0000123', '0000456']
       * 找到 ['0000123', '0000456'] 中包含的 skuCode 所在行，设置 class-name
       */
      handleRowClassName({ row }) {
        const rowClassValues = this.rowClassValues
        if (
          rowClassValues?.fieldKey &&
          rowClassValues?.fieldValue &&
          rowClassValues?.fieldValue.includes(row[rowClassValues?.fieldKey])
        )
          return 'vxe-row-bg'
      },

      updateFooter() {
        this.$refs.mgTable.updateFooter()
      },

      setCurrentRow(row) {
        this.$refs.mgTable.setCurrentRow(row)
      },

      getRowid(row) {
        return this.$refs.mgTable.getRowid(row)
      },

      setCurrentColumn(column) {
        this.$refs.mgTable.setCurrentColumn(column)
      },

      scrollToRow(row) {
        this.$refs.mgTable.scrollToRow(row)
      },

      setCheckboxRow(rows, checked) {
        this.$refs.mgTable.setCheckboxRow(rows, checked)
      },

      getCheckboxRecords() {
        return this.$refs.mgTable.getCheckboxRecords()
      },

      setAllCheckboxRow(checked) {
        this.$refs.mgTable.setAllCheckboxRow(checked)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '../style/index.scss';

  ::v-deep(.vxe-table--render-default .vxe-body--column.col--selected) {
    box-shadow: none;
  }
  ::v-deep(
      .is--disabled .vxe-checkbox--icon,
      .vxe-table--render-default .is--disabled.vxe-cell--checkbox .vxe-checkbox--icon
    ) {
    background-color: #edf2fc !important;
    border-color: #dcdfe6 !important;
  }
  ::v-deep(.mg-setting-icon-btn),
  ::v-deep(.mg-setting-icon-btn:hover),
  ::v-deep(.mg-setting-icon-btn:focus) {
    border-color: #d2d3d7;
  }
  ::v-deep(.mg-setting-icon-btn .mg-setting-icon-img) {
    width: 20px;
    height: 20px;
    display: inline-block;
    background: url('@/assets/common/icon_set_new.png') no-repeat center;
    background-size: contain;
    flex-shrink: 0;
  }
  // 统一 vxe 顶栏操作区视觉高度，避免业务页样式覆盖后错位
  ::v-deep(.mg-virtual-table-topbar .topbar-left),
  ::v-deep(.mg-virtual-table-topbar .topbar-right) {
    height: var(--mg-op-btn-height);
    display: flex;
    align-items: center;
  }
  ::v-deep(.mg-virtual-table-topbar) {
    padding: 8px 8px 8px 0;
    margin-bottom: 0;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-right) {
    flex: 1;
    justify-content: flex-end;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-right .mg-export-button) {
    margin-right: 0;
    margin-left: 0;
    order: 0;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-left .mg-export-button),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .mg-export-button) {
    height: var(--mg-op-btn-height);
    min-height: var(--mg-op-btn-height);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  ::v-deep(
      .mg-virtual-table-topbar .topbar-left .el-button:not(.el-button--icon):not(.el-button--text):not(.mg-export-button)
    ),
  ::v-deep(
      .mg-virtual-table-topbar .topbar-right .el-button:not(.el-button--icon):not(.el-button--text):not(.mg-export-button)
    ) {
    height: var(--mg-op-btn-height);
    min-height: var(--mg-op-btn-height);
    line-height: var(--mg-op-btn-height);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  ::v-deep(
      .mg-virtual-table-topbar .topbar-left .el-button:not(.el-button--icon):not(.el-button--text):not(.mg-export-button)
    ) {
    font-size: 18px;
    font-style: normal;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-left .el-button--icon),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .el-button--icon),
  ::v-deep(.mg-virtual-table-topbar .topbar-left .mg-setting-icon-btn),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .mg-setting-icon-btn) {
    width: var(--mg-op-icon-size);
    min-width: var(--mg-op-icon-size);
    height: var(--mg-op-icon-size);
    min-height: var(--mg-op-icon-size);
    box-sizing: border-box;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  // 设置按钮图标居中：清除文字基线影响
  ::v-deep(.mg-virtual-table-topbar .topbar-left .mg-setting-icon-btn),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .mg-setting-icon-btn) {
    font-size: 0;
    line-height: 0;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-left .mg-setting-icon-btn .mg-setting-icon-img),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .mg-setting-icon-btn .mg-setting-icon-img) {
    display: block;
    margin: auto;
  }
  ::v-deep(.mg-virtual-table-topbar .topbar-left .el-button--icon .iconfont),
  ::v-deep(.mg-virtual-table-topbar .topbar-right .el-button--icon .iconfont) {
    vertical-align: 0;
  }
  ::v-deep(.mg-customer-table-header-cell-body .mg-header-search-reset-wrap) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    min-height: 40px;
    box-sizing: border-box;
    padding-left: 2px;
    padding-top: 2px;
    background-color: transparent !important;
  }
  ::v-deep(.mg-customer-table-header-cell-body .mg-header-search-reset-btn) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin: 0;
    padding: 0;
    border: none !important;
    background-color: transparent !important;
    min-height: 40px;
  }
  ::v-deep(.mg-customer-table-header-cell-body .mg-header-search-reset-btn:hover),
  ::v-deep(.mg-customer-table-header-cell-body .mg-header-search-reset-btn:focus),
  ::v-deep(.mg-customer-table-header-cell-body .mg-header-search-reset-btn:active) {
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }
</style>
